<template>
    <div class="error-body">
        <div class="text">
            <span class="oops">Încă lucrăm!</span>
            <img src="@/assets/images/construction-background.jpg">
        </div>
        <div class="info-text">
            <span>ACEASTĂ PAGINĂ ESTE ÎNCĂ ÎN CONSTRUCȚIE</span>
            <p>Vă mulțumim pentru întelegere.</p>
            <br>
            <!--<p>Poți alege una din paginile de mai jos:</p>-->
            <!--<ul>-->
            <!--<li><router-link to="/">Acasă</router-link></li>-->
            <!--<li><router-link to="/contul-meu">Contul meu</router-link></li>-->
            <!--<li><router-link to="/companiile-mele">Companiile mele</router-link></li>-->
            <!--<li><router-link to="/toate-finantarile">Toate finanțările</router-link></li>-->
            <!--<li><router-link to="/cauta-consultant">Caută consultant</router-link></li>-->
            <!--</ul>-->
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.$store.dispatch('pageLoading/setLoading', false)
        }
    }
</script>

<style scoped>
.error-body{
    height: calc(100vh - 70px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
}
.oops{
    font-size: 9rem;
    font-weight: 900;
    letter-spacing: 4px;
}
.text{
    position: relative;
    margin-bottom: 20px;
}
.text img{
    position: absolute;
    top: 5%;
    left: 0;
    mix-blend-mode: lighten;
    width: 100%;
    object-fit: cover;
    animation: scaleImage 3s ease-in-out infinite alternate;
}
@keyframes scaleImage {
    0%   {transform: scale(1.0)}
    100%   {transform: scale(1.3)}
}
.info-text, .info-text p{
    text-align: center;
    font-size: 13px;
}
.info-text{
    width: 30%;
}
.link-to-go{
    color: #5355d1;
}
.info-text span{
    font-weight: 700;
    font-size: 18px;
}
.info-text ul{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}
ul li a{
    font-size: 13px;
    background-image: linear-gradient(
        180deg
        , #5b3cd0, #3bc6d4);
    color: #fff;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 5px 7px;
    white-space: nowrap;
    text-align: center;
}
@media (max-width:1100px){
    .oops{
        font-size: 6rem;
    }
    .error-body{
        padding: 0 20px;
        height: auto;
    }
}
@media (max-width:890px){
    .info-text ul{
        display: block;
    }
    .text img{
        left: 0;
    }
    ul li{
        margin-top: 17px;
    }
}
@media (max-width:500px){
    .oops{
        font-size: 4.5rem;
    }
}
</style>